


















































import Vue from 'vue'
import ChangeColors from '@/components/ChangeColors.vue'

export default Vue.extend({
  components: {
    appChangeColors: ChangeColors,
  },
  data() {
    return {
      menu: false,
      colorsDialog: false,
      image: new FileReader().result,
    }
  },
  methods: {
    // changeBackground(): void {
    //   const fileInput = document.createElement('input');
    //   fileInput.type = 'file';
    //   fileInput.accept = 'image/*';
    //   fileInput.oninput = e => {
    //     const target = e.target as HTMLInputElement;
    //     const files = target.files;
    //     if (!files || !files.length) return;
    //     const fr = new FileReader();
    //     fr.onload = (): void => {
    //       const image = fr.result;
    //       this.image = image;
    //       localStorage.setItem('drawerBackground', JSON.stringify(image));
    //     };
    //     fr.readAsDataURL(files[0]);
    //   };
    //   fileInput.click();
    // },
    onChange(value: boolean) {
      localStorage.setItem('darkMode', String(value))
    },
    changeColors() {
      this.colorsDialog = true
    },
  },
})
